/**
 * Экран «Возражения» (#846, программа «Голос клиента» #841): все возражения
 * окна, а не только неотработанные, в двух взглядах.
 *
 * - **Рынок** — о чём говорят клиенты: сколько разговоров, доля и сдвиг против
 *   прошлого окна той же длины, их словами, на каком этапе сделки и чем
 *   сделка кончилась после разговора.
 * - **Команда** — как это отрабатывают: доля неотработанных, средний балл,
 *   операторы, которые роняют код чаще других (от трёх разговоров), лучшие
 *   ответы из стенограмм.
 *
 * Один компонент для портала (`/analytics/objections`) и для встроенного
 * Bitrix24 (вкладка `objections`): данные и права у них общие. Состояние —
 * период, проекты, категория, взгляд, раскрытый код — живёт в адресе
 * оболочки (`search` / `onSearchChange`): цитата уводит в разговор, и «Назад»
 * возвращает к тому же экрану, а не к фильтру ссылки.
 */
import { ObjectionsList } from './ObjectionsList';
import type { ObjectionsSearch } from './objections-search';
import { useObjectionStream } from './useObjectionStream';
import { StreamFilterBar } from '../stream-filter/StreamFilterBar';

export interface ObjectionsViewProps {
  search: ObjectionsSearch;
  /** Merge a change into the shell's address (replacing the history entry). */
  onSearchChange: (patch: Partial<ObjectionsSearch>) => void;
}

export function ObjectionsView({ search, onSearchChange }: ObjectionsViewProps) {
  const { query: stream, streamWindow } = useObjectionStream(
    search,
    onSearchChange,
    false
  );
  const { period, navigation, projectIds, callCategory } = streamWindow;

  return (
    <div className="space-y-4">
      <StreamFilterBar
        period={period}
        navigation={navigation}
        projectIds={projectIds}
        callCategory={callCategory}
        isLoading={stream.isFetching && !stream.isLoading}
        onSearchChange={onSearchChange}
      />
      <ObjectionsList stream={stream} search={search} onSearchChange={onSearchChange} />
    </div>
  );
}
